import { storage } from '@/utils/storage'
import { convertEventName } from '@/utils/convertEventName'

export default defineNuxtPlugin((nuxtApp) => {
  const { $bridge, $gtag, $fb, $kwaiq, $tiktok } = nuxtApp

  let pageTitle = ''

  function push(obj, eventID = null) {
    const userInfoStore = nuxtApp.$pinia?._s.get('userInfo')
    const profile = userInfoStore?.userInfo || {}
    const user_properties = {
      level: profile.level || 0,
      channel: profile.channel || '',
      subChannel: profile.sub_channel || '',
      strategy: profile.strategy || '',
      scope: profile.scope || '',
      topup: profile.topup || 0,
      verification_status: profile.verification_status || 0,
      uidSite: profile.uid_site || '',
      user_tag_RFM: profile.user_tag || '',
      agent_id: profile.agent_id || '',
    }
    const objData = { ...obj, user_id: user_properties.uidSite, user_properties }
    setPageTitle(objData)

    const kpix = storage.get('kpix')
    if ($kwaiq?.instance && kpix) {
      $kwaiq.instance(kpix)?.track(convertEventName(obj.event, 'kwai'), objData)
    }
    if ($gtag) {
      $gtag('event', obj.event, objData)
    }
    // TODO: 處理事件對應
    if ($fb) {
      $fb.query('trackCustom', convertEventName(obj.event, 'facebook'), objData, eventID)
    }
    if ($tiktok) {
      $tiktok.track(convertEventName(obj.event, 'tiktok'), objData)
    }
    if ($bridge?.available) {
      $bridge.callHandler('pushEvents', objData, () => {
        console.log('[Bridge] Push Events')
      })
    }
    window.jsBridge?.postMessage(obj.event, JSON.stringify(objData || {}))
    console.info(
      `%c[Analytics][DEFAULT: ${obj.event} | KWAI: ${convertEventName(obj.event, 'kwai')} | FB: ${convertEventName(obj.event, 'facebook')} | TIKTOK: ${convertEventName(obj.event, 'tiktok')}]`,
      'background-color: #fff000; color: #000000;'
    )
    // 重置pageTitle
    if (objData.event === 'close_page') {
      pageTitle = ''
    }
  }

  function setPageTitle(objData) {
    // 暫存pageTitle
    if (objData.page_title) {
      pageTitle = objData.page_title
    }

    // error_event 帶入暫存pageTitle
    if (objData.event === 'error_event') {
      objData.page_title = pageTitle ? pageTitle : document.title
    }
  }

  const analytics = {
    push,
  }

  return {
    provide: {
      analytics,
    },
  }
})
